export class PzoneCode {
    eventType: string;
    province: string;
    trackCode: string;
    pzoneCode: string;
}